import axios from 'axios';
import { getUrls } from '../../../utils/url';
import { getUserUuidHeaders } from '../../../utils/httpUtils';

const { api } = getUrls();

export const getTab = async (meetingId, tabId, classSessionUuid, userUuid) => {
    const response = await axios.post(`${api}/meeting/${meetingId}/get_tab`, {
        data: {
            class_session_uuid: classSessionUuid,
            tab_id: tabId
        }
    }, { headers: getUserUuidHeaders(userUuid) });

    return response.data;
};
